/* tslint:disable */

/**
 */
export class NotifyInput {
    style_search?: string;
    key_input?: string;
}
